<template>
  <div class="template-selector p-3 mb-3">
    <div class="current-template p-3 mb-3">
      <div
        class="site-selector mb-3 d-flex gap-2 align-items-center"
        data-v-539d2e29=""
      >
        <div class="me-2" data-v-539d2e29="">Website:</div>
        <div class="sites-scroll d-flex gap-2">
          <button
              v-for="site in sites"
              :key="site.id"
              @click="selectSite(site.id)"
              :class="['site-pill', { active: site.id === currentSiteId }]"
          >
            <img :src="site.favicon" alt="" class="site-fav" v-if="site.favicon" />
            <span class="site-name">{{ site.name }}</span>
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="mb-1">Current template: {{ currentTemplate?.theme?.name }}</h5>
          <small class="text-muted">version: {{ currentTemplate?.git_branch }}</small>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <div class="two-part-btn">
            <button class="main-btn" @click="mainAction">
              Manage template
            </button>
            <button class="icon-btn" @click="toggleDropdown">
              <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-compact-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 11l8 3l8 -3" /></svg>
            </button>

            <div v-if="dropdownOpen" class="version-dropdown">
              <div v-for="v in currentTemplate.versions" :key="v" class="version-item">
                <button class="btn btn-sm btn-link w-100 d-flex" @click="customizeVersion(v.name)">
                  <span class="version-label col">{{ v.name }}</span>
                  <span class="version-actions col-auto">
                    <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="installed-templates" v-if="templates?.length > 0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-2">Installed templates</h3>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-primary" @click="addNewTemplate">Add new template</button>
        </div>
      </div>
      <div class="templates-grid d-flex flex-wrap gap-3">
        <div v-for="t in otherTemplates" :key="t.id" class="template-card modern-card">
          <div class="template-thumbnail" v-if="t.theme.preview_image">
            <img :src="t.theme.preview_image" alt="preview" />
          </div>
          <div class="template-name text-center mt-1">{{ t?.theme?.name }}</div>
          <div class="template-actions d-flex justify-content-center gap-1 mt-2">
            <button class="btn btn-sm btn-secondary" @click="customizeTemplate(t)">Customize</button>
            <button class="btn btn-sm btn-info" @click="previewTemplate(t)">Preview</button>
            <button class="btn btn-sm btn-success" @click="setDefaultTemplate(t)">Set default</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../modules/http";
export default {
  props: {
    sites: {
      type: Array,
      required: true,
    },
    templates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSiteId: 1,
      currentTemplateId: 1,
      dropdownOpen: false,
    };
  },
  computed: {
    currentTemplate() {
      return this.templates?.find(t => t.id === this.currentTemplateId);
    },
    otherTemplates() {
      return this.templates?.filter(t => t.id !== this.currentTemplateId);
    },
    currentSite() {
      return this.sites.find(s => s.id === this.currentSiteId) || this.sites[0];
    },
  },
  watch: {
    sites(){
      this.currentSiteId = this.sites[0].id;
    },
    currentSiteId() {
      this.currentTemplateId = this.currentSite.webshop_template_id;
    },
  },
  methods: {
    updateTemplate(id) {
      http.fetch('/themes/template/'+id+'/update',{});
    },
    selectSite(id) {
      this.currentSiteId = id;
      this.dropdownOpen = false;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    changeVersion(version) {
      this.currentTemplate.version = version;
      this.dropdownOpen = false;
      alert(`Sablon verzió váltva: ${version}`);
    },
    mainAction() {
      window.open(`https://${this.currentSite.domain}${this.currentSite.slug.length > 0 ? "/"+this.currentSite.slug : ""}/set-template/${this.currentTemplate.preview_hash}`, '_blank').focus();
    },
    editPages() {
      alert(`Oldalak szerkesztése: ${this.currentTemplate.name}`);
    },
    addNewTemplate() {
      alert('Új sablon hozzáadása');
    },
    previewVersion(version) {
      alert(`Előnézet verzió: ${version}`);
    },
    customizeVersion(version) {
      window.open(`https://${this.currentSite.domain}${this.currentSite.slug.length > 0 ? "/"+this.currentSite.slug : ""}/set-template/${this.currentTemplate.preview_hash}/${version}`, '_blank').focus();
    },
    customizeTemplate(t) {
      alert(`Személyre szabás: ${t.name}`);
    },
    previewTemplate(t) {
      alert(`Előnézet: ${t.name}`);
    },
    setDefaultTemplate(t) {
      this.currentTemplateId = t.id;
      alert(`Alapértelmezett sablon: ${t.name}`);
    },
  },
};
</script>

<style scoped>
.template-selector {
  border-radius: 0.5rem;
  background: #ccdaef;
  box-shadow: 0px 0px 2px 0px #8d8d8d;
}

.current-template {
  background: #713AE8;
  background: linear-gradient(153deg,rgba(113, 58, 232, 1) 0%, rgba(139, 73, 227, 1) 66%, rgba(180, 96, 220, 1) 100%);
  border-radius: 0.5rem 0.5rem 0 0;
  margin: -1em -1em 3em -1em !important;
  color: #fff;
  overflow: visible;
}
.two-part-btn {
  position: relative;
  display: flex;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}
.icon-btn {
  background: #fff;
  border: none;
  padding: 0.5rem 0.75rem;
  color: #000;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.main-btn {
  background: #fff;
  border: none;
  padding: 0.5rem 1rem;
  color: #000;
  flex-grow: 1;
  cursor: pointer;
  text-align: left;
}
.icon-btn:hover, .main-btn:hover {
  opacity: 0.85;
}
.version-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  color: #000;
  border-radius: 0.5rem;
  width: max-content;
  min-width: 200px;
  margin-top: 0.25rem;
  z-index: 1050;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  padding: 0.5rem;
}
.version-item {
  display: flex;
  margin-bottom: 0.5rem;
}
.version-actions button {
  font-size: 0.75rem;
}
.installed-templates h6 {
  margin-bottom: 0.5rem;
}
.templates-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.template-card.modern-card {
  width: 320px;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  padding: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;
}
.template-card.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.template-thumbnail img {
  width: 100%;
  border-radius: 0.5rem;
}
.template-name {
  font-weight: 500;
  text-align: center;
  margin-top: 0.5rem;
}
.template-actions button {
  font-size: 0.75rem;
  flex: 1;
}
.template-selector-multi { font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial; }
.site-selector { background: transparent; }
.sites-scroll { overflow-x: auto; padding-bottom: 4px; }
.site-pill { display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.4rem 0.75rem; border-radius: 999px; border: 1px solid transparent; background: #f3f6fb; cursor: pointer; }
.site-pill.active { background: #0056ab; color: #fff; border-color: rgba(0,0,0,0.05); }
.site-fav { width: 18px; height: 18px; border-radius: 3px; object-fit: cover; }
</style>
